var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArchive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: props.fill
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 12.2a.8.8 0 000 1.6h4.5a.8.8 0 000-1.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M1.45 8.5c0 .84.667 1.523 1.5 1.55v8.2A1.55 1.55 0 004.5 19.8h15a1.55 1.55 0 001.55-1.55v-8.2a1.55 1.55 0 001.5-1.55V6.25A1.55 1.55 0 0021 4.7H3a1.55 1.55 0 00-1.55 1.55zm1.6-2.2v2.15h17.9V6.3zm16.4 11.9v-8.15H4.55v8.15z",
    fillRule: "evenodd"
  }))));
}

export default SvgArchive;